import { useState } from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/ui/empty-state'
import type { RegistrationComparison } from '@/lib/registration-comparison'
import { chartData } from './registration-chart-data'
import { RegistrationChartTable } from './registration-chart-table'
import { RegistrationChartPlot } from './registration-chart-plot'

export function RegistrationChart({ report }: { report: RegistrationComparison }) {
  const [table, setTable] = useState(false)
  const data = chartData(report)
  const empty = data.current.length + (data.previous?.length ?? 0) === 0
  return (
    <Card className="mt-4 min-w-0 p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <h2 className="text-body font-medium text-foreground">Places held</h2>
          <ul className="flex items-center gap-4 text-caption text-muted-foreground">
            <li className="flex items-center gap-1.5">
              <span aria-hidden="true" className="h-0.5 w-5 rounded-full bg-primary" />
              {data.currentLabel}
            </li>
            {data.previous && (
              <li className="flex items-center gap-1.5">
                <span
                  aria-hidden="true"
                  className="w-5 border-t border-dashed border-muted-foreground/70"
                />
                {data.previousLabel}
              </li>
            )}
          </ul>
        </div>
        <Button type="button" variant="ghost" size="sm" onClick={() => setTable(!table)}>
          {table ? 'View as chart' : 'View as table'}
        </Button>
      </div>
      <div className="mt-3">
        {empty ? (
          <EmptyState title="No chart data available" />
        ) : (
          <ChartView table={table} data={data} />
        )}
      </div>
    </Card>
  )
}

function ChartView({ table, data }: { table: boolean; data: ReturnType<typeof chartData> }) {
  return table ? <RegistrationChartTable data={data} /> : <RegistrationChartPlot data={data} />
}
